import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, View, ViewHeader } from '../components/Index';
import { AppPermissions } from '../services/AppPermissions';

export const PageNotFoundView: React.FC = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <View id="PageNotFoundView" authKey={AppPermissions.PublicAccess}>
        <ViewHeader title="Page Not Found!">
          <Button title="Back" className="btn-secondary" icon="arrow-left" onClick={() => navigate(-1)} />
        </ViewHeader>
        <div className="p-8">
          <div className="bg-white rounded-xl mb-4 text-center py-16 px-6 shadow-card border border-gray-25 space-y-8">
            <div>
              <h2 className="font-medium text-lg md:text-2xl text-gray-800">Sorry!</h2>
              <p className="text-gray-500 max-w-2xl mx-auto text-sm md:text-base">
                You're looking for a page which is not found in the application. Please contact system administrator for more information.
              </p>
            </div>
          </div>
        </div>
      </View>
    </>
  );
};
